import { FC } from 'react';
import { useTenantSecretMappingForm } from 'TenantModule/components/TenantSecretMappingForm/useTenantSecretMappingForm';
import { TenantSecretMappingForm } from 'TenantModule/components/TenantSecretMappingForm/TenantSecretMappingForm';
import { StyledSimpleCard } from 'styles';

export const TenantSecretMappingCard: FC = () => {
  const tenantSecretMappingFormProps = useTenantSecretMappingForm();

  return (
    <StyledSimpleCard>
      <TenantSecretMappingForm {...tenantSecretMappingFormProps} />
    </StyledSimpleCard>
  );
};
